<template>
    <div class="py-3 flex-fill scrollable">
        <b-container>
            <b-row align-h="center" class="w-100">
                <b-col lg="8" xl="6">
                    <slot name="title">
                        <h2 class="no-print">
                            {{ $t($route.meta.title) }}
                        </h2>
                    </slot>
                    <b-breadcrumb :items="breadcrumbs" class="p-0 bg-transparent" />
                    <slot name="content"></slot>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'PageBaseComponent',
    mixins: [ AppData ],
    props: {
        taxpayerInfo: Object,
        moneyPlacementName: String
    },
    computed: {
        breadcrumbs: function () {
            var breadcrumbs = []
            if (this.$route.meta.breadcrumbs) {
                this.$route.meta.breadcrumbs.forEach(element => {
                    if (element.text === 'dealerName') {
                        breadcrumbs.push({
                            text: this.taxpayerInfo ? this.taxpayerInfo.name : null,
                            to: element.to,
                            active: element.active
                        })
                        return
                    }
                    if (element.text === 'ticketName') {
                        breadcrumbs.push({ text: `${this.$t('menu.ticketDetails')} ${this.$route.params.id}`, active: element.active, to: element.to })
                        return
                    }
                    if (element.text === 'reportName') {
                        breadcrumbs.push({ text: `${this.$t('menu.reportDetails')} ${this.$route.params.id}`, active: element.active, to: element.to })
                        return
                    }
                    if (element.text === 'moneyPlacementName') {
                        breadcrumbs.push({ text: `${this.moneyPlacementName} ${this.$route.params.id}`, active: element.active, to: element.to })
                        return
                    }
                    breadcrumbs.push({ text: this.$t(element.text), to: element.to })
                })
            } else {
                this.$route.matched.slice().forEach(element => {
                    breadcrumbs.push({ text: this.$t(element.meta.title), to: { name: element.name } })
                })
            }
            return breadcrumbs
        }
    },
    watch: {
        taxpayerInfo: function (newVal) {
            this.taxpayerInfo = newVal
        },
        reportName: function (newVal) {
            this.reportName = newVal
        },
        ticketName: function (newVal) {
            this.ticketName = newVal
        },
        moneyPlacementName: function (newVal) {
            this.moneyPlacementName = newVal
        }
    }
}
</script>
